import { UserContact } from '../iContact/user-contact';

export interface HistoryDTO {
  id: number;
  mailId: number;
  modifieLe?: string; // ($date-time)
  type?: string;
  description?: string;
  modifieParContactIdiAdmin?: number;
  traductionFr?: string;
  traductionNl?: string;
  traductionDe?: string;
  traductionEn?: string;
  traductionLu?: string;
}

export class History {
  id: number;
  mailId: number;
  modifieLe?: string; // ($date-time)
  type?: string;
  description?: string;
  modifieParContactIdiAdmin?: number;
  traductionFr?: string;
  traductionNl?: string;
  traductionDe?: string;
  traductionEn?: string;
  traductionLu?: string;
  name: string;

  constructor(data: HistoryDTO, userList?: UserContact[]) {
    Object.assign(this, data);
    if (userList?.length && data.modifieParContactIdiAdmin) {
      this.setName(userList.find((user) => user.contactId === data.modifieParContactIdiAdmin));
    } else if (!data.modifieParContactIdiAdmin) {
      this.name = 'Système';
    }
  }

  private setName(userContact: UserContact): void {
    this.name = userContact ? `${userContact.contactForUser?.nom ?? ''} ${userContact.contactForUser?.prenom ?? ''}` : '';
  }
}
